import keyboardFocus from 'keyboard-focus';
import { initScroll } from './smooth-scroll';
import footer from './footer';
export default () => {
  keyboardFocus(document);
  initScroll();
  footer();
};